'use strict';

export default function routes($stateProvider) 
{
	'ngInject';

	//console.log("Importing events:routes");

	$stateProvider
		.state('futureevents', {
			url: '/el',
			params: null,
			template: require('./future_events.html'),
			controller: 'FutureEventsController',
			controllerAs: 'vm'
		})
		.state('concludedevents', {
			url: '/er',
			params: null,
			template: require('./concluded_events.html'),
			controller: 'ConcludedEventsController',
			controllerAs: 'vm'
		});
}


// WEBPACK FOOTER //
// ./client/app/frontend/events/events.routes.js